/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IAppHubScope extends ng.IScope {
        vm: AppHub;
    }

    interface IAppHub {
        expanded: boolean;
        applications: Array<appHubViewModel>;
        crossroadsUrl: string;
        apiHost: string;
        transcripts: Array<any>;
        getUserApplicationsTryCount: number;
    }

    class AppHub implements IAppHub {
        static controllerId: string = "appHub";
        static $inject: Array<string> = ["$scope",
            "$window",
            "applicationsDataService",
            "transcriptDataService",
            "$uibModal",
            "common",
            "config",
            "Restangular",
            "Upload",
            "$http",
            "$location",
            "$document",
            "$interval",
            "Idle",
            "helper"
        ];
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        expanded: boolean;
        applications: Array<appHubViewModel>;
        crossroadsUrl: string;
        apiHost: string;
        transcripts: Array<any>;
        getUserApplicationsTryCount: number = 0;
        errorGettingApplications: boolean = false;
        printing: any;
        emailing: any;
        refreshing: boolean = false;
        alerts: Array<any> = [];
        childWindows: Array<any> = [];
        timer: any = 0;
        userInfo: IUserInfoView;
        apphubNotification: any;

        constructor(private $scope: ng.IScope,
            private $window: ng.IWindowService,
            private applicationsDataService: IApplicationsDataService,
            private transcriptDataService: ITranscriptDataService,
            private $uibModal: ng.ui.bootstrap.IModalService,
            private common: ICommonFactory,
            private config: IConfig,
            private Restangular: Restangular.IService,
            private Upload,
            private $http: any,
            private $location: ng.ILocationService,
            private $document: ng.IDocumentService,
            private $interval: ng.IIntervalService,
            private Idle,
            private helper: IHelper) {
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.log = common.logger.getLogFn(AppHub.controllerId);
                    this.logError = common.logger.getLogFn(AppHub.controllerId, "error");
                    this.logSuccess = common.logger.getLogFn(AppHub.controllerId, "success");


                    this.common.authentication.isLoggedIn().then(loggedIn => {
                        if (loggedIn) {
                            this.userInfo = this.common.authentication.user;
                            this.activate();
                            this.expanded = false;
                            this.crossroadsUrl = config.crossroadsUrl;
                            this.apiHost = config.apiHost;
                        }
                    });



                }
            });

            
            $scope.$on('$destroy', function () {
                Idle.watch();
            });

            //$scope.$on(config.events.logout, (event) => {
            //    this.common.authentication.authenticate(true);
            //});
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, AppHub.controllerId)
                .then(() => {
                    this.getAppHubNotification()
                    this.refreshing = true;
                    this.getUserApplications();

                    this.log("Activated AppHub View");

                });
        }

        getUserApplications() {
            this.applications = null;
            this.applicationsDataService.getUserApplications().then((data) => {
                this.applications = data.applications;
                this.refreshing = false;
            }, (reason) => {
                if (this.getUserApplicationsTryCount < 2) {
                    this.getUserApplicationsTryCount += 1;
                    this.getUserApplications();

                }
                else {
                    this.errorGettingApplications = true;
                    console.log(reason);
                    this.refreshing = false;
                }
            });
        }

        openTranscriptActivity(transcriptStatus, orgName) {
            var data = {
                firstName: this.common.authentication.user.firstName,
                lastName: this.common.authentication.user.lastName,
                studentId: transcriptStatus[0].studentId,
                transcriptStatus: transcriptStatus,
                organizationName: orgName
            };
            console.log(this.common.authentication.user);
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/apphub/transcriptActivityModal.html',
                controller: 'transcriptActivityModal',
                size: 'xl',
                resolve: {
                    data: function () { return data; }
                }
            });
        }

        openTranscriptMessage() {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/apphub/transcriptmessagemodal.html',
                controller: 'transcriptMessageModal',
            });
        }

        openStartApp() {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/apphub/startnewappmodal.html',
                controller: 'startNewAppModal',
                size: 'lg',
                backdrop: 'static',
            });

            modalInstance.result
                .then(() => { this.log("update apphub data to reflect new apps"); });
        }

        viewApp = (selectedApp) => {
            var appWindow;
            if (selectedApp.userApplication.completed) {
                appWindow = this.$window.open(this.config.crossroadsUrl + "/application/completed/" + selectedApp.userApplication.id, "_blank");
            } else {
                this.Restangular.one("Prospect/" + selectedApp.userApplication.applicationDefinitionId).one("isRecruited").get().then((results) => {
                    if (!results) {
                        this.Restangular.all("Prospect/addRecruiter").post({ applicationDefinitionId: selectedApp.userApplication.applicationDefinitionId, source: "Application" })
                            .then((results) => {
                                console.log(results);
                            }, (reason) => {
                                console.error(reason);
                            });
                    }
                }, (reason) => {
                    console.error(reason);
                });

                appWindow = this.$window.open(this.config.crossroadsUrl + "/" + selectedApp.viewUrl, "_blank");
            }

            this.addChildWindow(appWindow);
        };

        addChildWindow = (appWindow) => {
            this.childWindows.push(appWindow);
            if (this.timer == 0) {
                console.log("timer started");
                this.Idle.unwatch();
                this.timer = this.$interval(this.checkWindow, 1000, 0, true);
            }
        };

        completionPercent(application) {
            var completed = 0;
            var total = 2;
            if (application.transcriptStatus.length > 0 && application.transcriptStatus[0].dateRequested && application.transcriptStatus[0].status != 'Failed') {
                completed += 1;
            }

            if (application.userApplication.completed) {
                completed += 1;

                if (application.userApplication.tasks) {
                    application.userApplication.tasks.forEach(function (task) {
                        total += 1;
                        if (task.completed) {
                            completed += 1;
                        }
                    });
                }
            } else {
                total += application.applicationTasks.length;
            }

            return (completed / total) * 100;
        }

        completionDisplay(application) {
            var completed = 0;
            var total = 0;

            if (application.hasApplication) {
                total += 1;
            }

            if (application.canReceiveTranscripts) {
                total += 1;
            }

            
            if (application.transcriptStatus.length > 0 && application.transcriptStatus[0].dateRequested && application.transcriptStatus[0].status != 'Failed') {
                completed += 1;
            }

            if (application.userApplication.completed) {
                completed += 1;

                if (application.userApplication.tasks) {
                    application.userApplication.tasks.forEach(function (task) {
                        total += 1;
                        if (task.completed) {
                            completed += 1;
                        }
                    });
                }
            } else {
                total += application.applicationTasks.length;
            }

            return `${completed}/${total}`;
        }

        deleteApplication(appId) {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/appHub/confirmRemoveModal.html',
                size: 'md',
                controller: 'ConfirmRemoveModal',
            });

            modalInstance.result.then((val: boolean) => {
                this.Restangular.one("application", appId).one("remove").remove().then(
                    (response) => {
                        this.getUserApplications();
                    }, (reason) => {
                        console.log(reason);
                    });
            });


        }

        inviteCounselor(userApplicationId, taskId) {
            var data = {
                userApplicationId: userApplicationId,
                taskId: taskId
            };
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/appHub/inviteThirdPartyModal.html',
                size: 'md',
                controller: 'InviteThirdPartyModal',
                resolve: {
                    data: function () { return data; }
                }
            });

            modalInstance.result.then((val: boolean) => {
                this.getUserApplications();
            });
        }

        upload = (id, taskId, files) => {
            var self = this;
            if (files.length > 0) {
                this.Upload.upload({
                    url: this.config.apiHost + "/application/" + id + "/" + taskId + "/attachment",
                    method: "POST",
                    file: files[0]
                }).success((data, status, headers, config) => {
                    this.addAlert("success", "File uploaded successfully", id);
                    var application = _.find(self.applications, (application: any) => {
                        return application.userApplication.id == id;
                    });

                    var task = _.find(application.userApplication.tasks, (task: any) => {
                        return task.applicationTaskId == taskId;
                    });

                    task.completedDate = new Date();
                    task.attachment = "/application/attachments/" + id + "/" + taskId;
                    if (task.applicationTask.uploadCompletesTask) {
                        task.completed = true;
                    }

                }).error((data, status, headers, config) => {
                    this.addAlert("alert", "File upload failed", id);
                });
            }

        };

        requestTranscript = (appid) => {
            sessionStorage.setItem('transcriptRequest.appid', appid);
            this.$location.path("apphub/requesttranscript");
        };

        print = ($event, application) => {
            application.printing = true;
            var location: any = window.location;
            var headHtml = "";
            $(this.$document[0]["head"]).children("link").each((i: number, l: any) => {
                headHtml += l.outerHTML;
            });
            var html = "<html><head>" + headHtml + "</head><body style='margin: 50px; background-color: #fff; background-image:none'>" + $($($event.target).parents(".card-content")[0]).find("h4").parent().html() + $($event.target).parents(".app-info")[0].innerHTML + "</body></html>";
            this.helper.openFile(this.config.apiHost + "/pdf/download", { html: encodeURIComponent(html), url: location.origin }).then(() => {
                application.printing = false;
            });

        };

        openFile = (attachmentUrl) => {
            this.helper.openFile(attachmentUrl);
        };

        email = ($event, application) => {
            application.emailing = true;
            var location: any = window.location;
            var headHtml = "";
            $(this.$document[0]["head"]).children("link").each((i: number, l: any) => {
                headHtml += l.outerHTML;
            });
            var html = "<html>" + headHtml + "<body style='margin: 50px; background-color: #fff; background-image:none'>" + $($($event.target).parents(".card-content")[0]).find("h4").parent().html() + $($event.target).parents(".app-info")[0].innerHTML + "</body></html>";
            this.Restangular.all("pdf").all("email").post({ html: encodeURIComponent(html), url: location.origin })
                .then((response) => {
                    application.emailing = false;
                    this.logSuccess("Email has been sent to the email address associated with your CFNC profile.", "Email has been sent to the email address associated with your CFNC profile.", true);
                }, (reason) => {
                    application.emailing = false;
                    this.logError("There was a problem sending your email.  Please try again later", reason, true);
                }, (state) => {
                    application.emailing = false;
                });
        }

        completeTask = (id, taskId) => {
            var self = this;
            this.Restangular.one("application").one(id).one(taskId).one("completed").get().then(
                (response) => {
                    var application = _.find(self.applications, (application: any) => {
                        return application.userApplication.id == id;
                    });

                    var task = _.find(application.userApplication.tasks, (task: any) => {
                        return task.applicationTaskId == taskId;
                    });

                    task.completedDate = new Date();
                    task.completed = true;
                },
                (reason) => {
                    console.log(reason);
                    this.addAlert("danger", "An error occurred. Please try again later.", id);
                });
        };

        uncompleteTask = (id, taskId) => {
            var self = this;
            this.Restangular.one("application").one(id).one(taskId).one("uncompleted").get().then(
                (response) => {
                    var application = _.find(self.applications, (application: any) => {
                        return application.userApplication.id == id;
                    });

                    var task = _.find(application.userApplication.tasks, (task: any) => {
                        return task.applicationTaskId == taskId;
                    });

                    task.completedDate = null;
                    task.completed = false;
                },
                (reason) => {
                    console.log(reason);
                    this.addAlert("danger", "An error occurred. Please try again later.", id);
                });
        };

        addAlert = (alertType, message, applicationDefinitionId) => {
            this.alerts.push({ type: alertType, message: message, applicationDefinitionId: applicationDefinitionId });
        }

        closeAlert = (index) => {
            this.alerts.splice(index, 1);
        }

        checkWindow = () => {
            for (var win = 0; win < this.childWindows.length; win++) {
                if (!this.childWindows[win]) {
                    this.childWindows.splice(win, 1);
                }
                else if (this.childWindows[win].closed) {
                    this.childWindows.splice(win, 1);
                    this.activate();
                }
            }

            if (this.childWindows.length == 0) {
                this.$interval.cancel(this.timer);
                this.timer = 0;
                this.Idle.watch();
            }
        }

        getAppHubNotification(): angular.IPromise<any> {
            return this.Restangular.withConfig(config => {
                config.setBaseUrl(this.config.umbracoUrl);
            }).one("api/sitenotifications").get({targets: "apphub"})
                .then(result => {
                    if (result && result.message) {
                        this.apphubNotification = result;
                    }
                }, error => {
                    this.logError(error);
                });
        }
    }

    angular.module("app").controller(AppHub.controllerId, AppHub);
}